import DamageReportEntity from '../entity/DamageReportEntity';
import { DamageReportLabelKey } from './DamageReport';

export const sortDamageReportLabelKey = (a: DamageReportLabelKey, b: DamageReportLabelKey) =>
  DamageReportEntity.LABELS.findIndex((value) => value.value === a) -
  DamageReportEntity.LABELS.findIndex((value) => value.value === b);
